<template>
    <v-card 
        class="pa-5 rounded-xl shadow" 
        flat
        :dark="dark"
    >
        <slot></slot>
    </v-card>
</template>

<script>
export default {
    props: {
        dark: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>
.shadow {
  box-shadow: rgba(0, 0, 0, 0.06) 0px 4px 12px !important;
  /* box-shadow: -10px -10px 15px rgba(255,255,255,0.5),
    10px 10px 15px rgba(70,70,70,0.12) !important; */
}
</style>